import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { LoadTpTemplates, TpTemplateDataSource, TpTemplateModel, TpTemplateState } from 'src/app/core/template';
import { PaginationEvent } from '../../../template/template-list/template-list.component';

@Component({
  selector: 'kt-tp-template-list-modal',
  templateUrl: './tp-template-list-modal.component.html',
  styleUrls: ['./tp-template-list-modal.component.scss']
})
export class TpTemplateListModalComponent implements OnInit {
  dataSource: TpTemplateDataSource;
  pageSize = 4;

  constructor(
    public dialogRef: MatDialogRef<TpTemplateListModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<TpTemplateState>
  ) { }

  ngOnInit(): void {
    this.dataSource = new TpTemplateDataSource(this.store);
    this.store.dispatch(new LoadTpTemplates({
      request: {
        pageNumber: 1,
        pageSize: this.pageSize
      }
    }));
  }

  loadList(event: PaginationEvent) {
    this.store.dispatch(new LoadTpTemplates({
      request: {
        pageNumber: event.pageNumber + 1,
        pageSize: event.pageSize
      }
    }));
  }

  selectTemplate(event: TpTemplateModel) {
    this.dialogRef.close({
      type: 'select',
      template: event
    });
  }

  viewTemplate(event: TpTemplateModel) {
    this.dialogRef.close({
      type: 'view',
      template: event
    })
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
